<template>
<ul class='result'>
    <!--<div class="divTable">-->
    <!--aaa{{publications}}-->
      <template v-for="(publication, i) in publications">
       <div :key="i" class="divTable">
        <div class="divRow" v-if="publication[AUTHOR].join('; ').length > 0" >
            <div class="divCell">Author, editor or organization</div>
            <div class="divCell2"><span v-html="publication[AUTHOR].join('; ')"></span></div>
        </div>
        <div class="divRow" v-if="publication[TITLE].length > 0">
            <div class="divCell">Title</div>
            <div class="divCell2"><span v-html="publication[TITLE].join('')"></span></div>
        </div>
        <div class="divRow" v-if="publication[REF]">
            <div class="divCell">Parent reference (in:)</div>
            <div class="divCell2"><span v-html="publication[REF].join('; ')"></span></div>
        </div>
        <div class="divRow" v-if="publication[PLACE]">
            <div class="divCell">Place of publication</div>
            <div class="divCell2"><span v-html="publication[PLACE]"></span></div>
        </div>
        <div class="divRow" v-if="publication[PUBLISHER]">
            <div class="divCell">Publisher</div>
            <div class="divCell2"><span v-html="publication[PUBLISHER]"></span></div>
        </div>
        <div class="divRow" v-if="publication[PERIOD]">
            <div class="divCell">Periodical</div>
            <div class="divCell2"><span v-html="publication[PERIOD]"></span></div>
        </div>
        <div class="divRow" v-if="publication[VOLUME]">
            <div class="divCell">Volume	Number</div>
            <div class="divCell2"><span v-html="publication[VOLUME]"></span></div>
        </div>
        <div class="divRow" v-if="publication[PAGE]">
            <div class="divCell">Page range</div>
            <div class="divCell2"><span v-html="publication[PAGE]"></span></div>
        </div>
        <div class="divRow" v-if="publication[YEAR]">
            <div class="divCell">Year</div>
            <div class="divCell2"><span v-html="publication[YEAR]"></span></div>
        </div>
        <div class="divRow" v-if="publication[REF_TYPE]">
            <div class="divCell">Reference type</div>
            <div class="divCell2"><span v-html="publication[REF_TYPE]"></span></div>
        </div>
        <div class="divRow" v-if="publication[CATEGORIES]">
            <div class="divCell">Categories</div>
            <div class="divCell2"><span v-html="publication[CATEGORIES].join('; ')"></span></div>
        </div>
        <div class="divRow" v-if="publication[SHELF]">
            <div class="divCell">Shelfmark</div>
            <div class="divCell2"><span v-html="publication[SHELF]"></span></div>
        </div>
        <div class="divRow" v-if="publication[BIB]">
            <div class="divCell">BibTeX key</div>
            <div class="divCell2"><a :href='`https://www.ikgf.uni-erlangen.de/aigaion2/bib/${publication[BIB].replace(/^.*\./, "")}.bib`' :download='`${publication[BIB].replace(/^.*\./, "")}.bib.txt`' target='bib'><span v-html="publication[BIB]"></span></a></div>
        </div>
    </div>
      </template>   
      <!--</div>-->
    </ul>
</template>

<script>
// const TITLE = 'title_text_cjk'
// const AUTHOR = 'author-editor-or-organization_ss'
// const YEAR = 'year-derived_s'
// const PUBLISHER = 'publisher_s'
// const VOLUME = 'volume_s'
// const PLACE = 'place-of-publication_s'
// const PERIOD = 'series_s'
// const REF_TYPE = 'reference-type_s'
// const PAGE = 'page-range_s'

  export default {
    name: 'recordList',
    props: ['publications'], 
    data: function (){
      return {
        TITLE : 'title_text_cjk',
 AUTHOR : 'author-editor-or-organization_ss',
 YEAR : 'year-derived_s',
 PUBLISHER : 'publisher_s',
 VOLUME : 'volume_s',
 PLACE : 'place-of-publication_s',
 PERIOD : 'series_s',
 REF_TYPE : 'reference-type_s',
 REF : 'ref_ss',
 PAGE : 'page-range_s',
 CATEGORIES : 'categories_ss',
 SHELF: 'shelfmark_s',
 BIB: 'sequence-number_s'

      }
    },
    methods: {
    //   getBib : function(seq){
    // //   console.log(this.records[item].Sequence_number);
    // //   var record = this.records[item];
    // //   var seq = record.Sequence_number;
    //   $.ajax({
    //     type: "GET",
    //     // url: "ikdf.csv",
    //     // dataType: "text",
    //     url:"bib/"+seq+".bib",
    //     dataType:"text",
    //     success: function(data) {
    //       var lines = data.split("\n");
    //       var authorPrefix = record.Author_editor_or_organization[0] ||"";
    //       authorPrefix = authorPrefix.replace(/,/g,'').split(" ")[0];
    //       var year = record.Year_indexed[0] || "";
    //       lines[0] = lines[0].replace(new RegExp("{"+seq+","),"{"+authorPrefix+year+",")
    //       // console.log(lines.join("\n"))
    //       var blob = new Blob([lines.join("\n")], {type: "text/plain;charset=utf-8"});
    //       saveAs(blob, authorPrefix+year+".bib");
    //     }
    //   });
    // },
      cslJson (pub) {
        // console.log(pub)
        let _item = pub
        let type = "";
      
      switch(_item[this.REF_TYPE]){
        case "Audio or Video Document":
           type= "article";
           break;
        case "Book":
           type= "book";
           break;
        case "Book, Edited":
           type= "book";
           break;
        case "Collected Work":
           type= "article";
           break;
        case "Conference Proceedings":
           type= "paper-conference";
           break;
        case "Contribution in…":
           type= "article";
           break;
        case "Internet Document":
           type= "webpage";
           break;
        case "Journal Article":
           type= "article-journal";
           break;
        case "Lecture":
           type= "article";
           break;
        case "Manuscript":
           type= "manuscript";
           break;
        case "Movie":
           type= "motion_picture";
           break;
        case "Musical Work / Music Album":
           type= "song";
           break;
        case "Report or Gray Literature":
           type= "article";
           break;
        case "Special Issue":
           type= "article";
           break;
        case "Thesis":
           type= "thesis";
           break;
      }
      
      // console.log(pub)
      
      var result = {
    type: type || '',
    title: _item[this.TITLE],
    author:[],
//     author: [
//       {
// 	given: "H. K.",
// 	family: "Hall"
//       }
//     ],
    issued: { 'raw': _item[this.YEAR] || '' } ,
    // issued: [],
    // containerTitle: _item.Series,
    // edition:_item.Edition || '',
    // ISBN: _item.ISBN || '',
    publisher: _item[this.PUBLISHER] ? _item[this.PUBLISHER] : '',
    issue:_item.Number|| '',
    volume: _item[this.VOLUME]|| '',
    page: _item[this.PAGE]|| '',
  }
  result['container-title']=_item[this.PERIOD] || '';
  result['publisher-place']=_item[this.PLACE] || '';

  _item[this.AUTHOR].reduce((acc, name)=>{
    let name_components = name.split(',')
    acc.push({
      family: name_components[0],
      given: name_components[1] || ''
    })
    return acc
  },
  result['author']
  )

  // for (let i=0; i < _item.author-editor-or-organization_ss.length; i++){
  //   let name_components = _item.author-editor-or-organization_ss[i].split(',');
    
  //   result['author'].push({
  //     family: name_components[0],
  //     given: name_components[1] || ''
  //   })
  // }
//   for (var i=0; i < _item.Year_indexed.length; i++){
//     var obj = {raw:_item.Year_derived};
//     result.issued.push({
// 	"date-parts": [ "1957", "1", "1" ]
//       });
//   }
  
  // console.log(result);
      return JSON.stringify(result);
      },
}
}
</script>
<style scoped>
    .divTable
    {
        display:  table;
        width:100%;
        
        border:1px solid  #666666;
        border-spacing:5px;
        border-collapse:separate;
    }

    .divRow
    {
       display:table-row;
       width:100%;
       /*background-color:#eee;*/
       border:1px solid  #666666;
       border-spacing:5px;
       border-collapse:separate;
    }

    .divCell
    {
        float:left;/*fix for  buggy browsers*/
        display:table-column;
        width:30%;
        /*background-color:#ccc;*/
    }
    .divCell2 {
        display:inline-block;
        width:70%;
        overflow-wrap: break-word;
    }
    
</style>